import React from 'react';

import { Form } from 'antd';
import cn from 'classnames';

import { Slider } from '@element/index';

import styles from './index.module.less'

const FormItem = Form.Item;

export const FormSlider = (props) => {
  const { name, rules, onChange } = props;
  return (
    <FormItem
      className={cn(styles.formItem, styles.wrapper)}
      shouldUpdate={(prevValues, curValues) => prevValues[name] !== curValues[name]}>
      {(form) => {
        return (
          <FormItem name={name} rules={rules} className={styles.formItem}>
            <Slider
              marks={{
                0: '0%',
                25: '25%',
                50: '50%',
                75: '75%',
                100: '100%'
              }}
              className={styles.slider}
              tipFormatter={(value) => `${value}%`}
              value={form.getFieldValue(name)}
              onChange={onChange}
            />
          </FormItem>
        )
      }}
    </FormItem>
  )
}
